exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#click_paso_pago span{\n    pointer-events: none;\n}\n.vs-input__label{\n    opacity: 1;\n}\n.country-selector__label, .input-tel__label{\n    top: 5px !important;\n}\n", ""]);

// exports
